module.exports = __webpack_public_path__ + "static/media/value2.66b127b9.svg";